import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { StreamAction } from '../stream.action';
import { StreamTranslator } from '../stream.translator';

type IDependencies = IClientApiDependencySegment;

export const loadStreamListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(StreamAction.loadList.started),
  switchMap((params) => {
    return dependencies.api.getStreamList(params).pipe(
      mergeMap((response) => {
        const result = (response.streams ?? []).map(StreamTranslator.fromApi);

        return [
          StreamAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          StreamAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
